import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-300a1472"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-lg font-bold text-textPrimary" }, "Grupos de colunas:", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M18.295 7.11502C18.6844 6.72565 18.6844 6.09438 18.295 5.70502C17.9056 5.31565 17.2744 5.31565 16.885 5.70502L12 10.59L7.115 5.70502C6.72564 5.31565 6.09436 5.31565 5.705 5.70502C5.31564 6.09438 5.31564 6.72565 5.705 7.11502L10.59 12L5.705 16.885C5.31564 17.2744 5.31564 17.9057 5.705 18.295C6.09436 18.6844 6.72564 18.6844 7.115 18.295L12 13.41L16.885 18.295C17.2744 18.6844 17.9056 18.6844 18.295 18.295C18.6844 17.9057 18.6844 17.2744 18.295 16.885L13.41 12L18.295 7.11502Z",
    fill: "#68688D"
  })
], -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "px-6 py-3" }
const _hoisted_5 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_6 = { class: "flex justify-end p-4" }

import { ref, watch, onBeforeUnmount, PropType } from 'vue'
import Checkbox from '@/components/designSystem/Checkbox/index.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
export interface ColumnOption {
  label: string
  value: string
  visible: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ColumnSelectorModal',
  props: {
  isOpen: {
    type: Boolean,
    required: true
  },
  columns: {
    type: Array as PropType<ColumnOption[]>,
    required: true
  }
},
  emits: ["update:isOpen", "apply"],
  setup(__props, { emit }) {

const props = __props;





const internalColumns = ref<ColumnOption[]>([])
const modalRef = ref<HTMLElement | null>(null)

const handleClickOutside = (event: MouseEvent) => {
  if (modalRef.value && !modalRef.value.contains(event.target as Node)) {
    closeModal()
  }
}

watch(
  () => props.isOpen,
  (newVal) => {
    if (newVal) {
      internalColumns.value = JSON.parse(JSON.stringify(props.columns))
      document.addEventListener('mousedown', handleClickOutside)
    } else {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }
)

onBeforeUnmount(() => {
  document.removeEventListener('mousedown', handleClickOutside)
})

function updateColumnVisibility({ isChecked, value }: { isChecked: boolean; value: string }) {
  const column = internalColumns.value.find((c) => c.value === value)
  if (column) {
    column.visible = isChecked
  }
}

function closeModal() {
  emit('update:isOpen', false)
}

function applyChanges() {
  emit('apply', internalColumns.value)
  closeModal()
}

return (_ctx: any,_cache: any) => {
  return (__props.isOpen)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        ref_key: "modalRef",
        ref: modalRef,
        onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
        class: "absolute right-0 z-20 mt-2 w-[615px] origin-top-right rounded-lg bg-white shadow-xl border border-gray-200"
      }, [
        _createElementVNode("div", { class: "flex items-center justify-between px-4 pt-4 pb-2" }, [
          _hoisted_1,
          _createElementVNode("button", {
            onClick: closeModal,
            class: "text-gray-400 hover:text-gray-600"
          }, _hoisted_3)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(internalColumns.value, (column) => {
              return (_openBlock(), _createElementBlock("div", {
                key: column.value
              }, [
                _createVNode(Checkbox, {
                  fieldId: `col-${column.value}`,
                  label: column.label,
                  value: column.value,
                  checked: column.visible,
                  "onUpdate:checked": updateColumnVisibility,
                  disabled: column.label === 'Plantão'
                }, null, 8, ["fieldId", "label", "value", "checked", "disabled"])
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(FilledButton, {
            text: "Aplicar alterações",
            color: "primary30",
            height: "48px",
            width: "180px",
            onClick: applyChanges
          })
        ])
      ], 512))
    : _createCommentVNode("", true)
}
}

})